import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast, Toaster } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await register({ ...f, role: "customer" });
            toast.success("Welcome to Hahnemann");
            nav("/");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Registration failed");
        } finally { setBusy(false); }
    };

    return (
        <div className="max-w-md mx-auto px-4 py-20" data-testid="register-page">
            <Toaster position="top-center" />
            <div className="text-center mb-10">
                <div className="label-eyebrow text-sky-700">Begin your journey</div>
                <h1 className="font-serif text-4xl text-stone-900 mt-2">Create account</h1>
            </div>
            <form onSubmit={submit} className="bg-white border border-stone-200 p-8 space-y-5">
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">Full name</Label>
                    <Input value={f.name} onChange={set("name")} className="rounded-none border-stone-300 mt-1" required data-testid="reg-name" /></div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">Email</Label>
                    <Input type="email" value={f.email} onChange={set("email")} className="rounded-none border-stone-300 mt-1" required data-testid="reg-email" /></div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">Phone</Label>
                    <Input value={f.phone} onChange={set("phone")} className="rounded-none border-stone-300 mt-1" data-testid="reg-phone" /></div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">Password (min 6)</Label>
                    <Input type="password" value={f.password} onChange={set("password")} className="rounded-none border-stone-300 mt-1" required data-testid="reg-password" /></div>
                <Button type="submit" disabled={busy} className="rounded-none w-full bg-sky-700 hover:bg-sky-800 text-stone-50 py-6" data-testid="reg-submit">
                    {busy ? "Creating…" : "Create account"}
                </Button>
                <p className="text-xs text-center text-stone-500">Have an account? <Link to="/login" className="text-sky-700 underline">Sign in</Link></p>
            </form>
            <p className="text-center text-[11px] text-stone-500 mt-4">
                HPL team member? <Link to="/staff-register" className="text-sky-700 underline font-medium" data-testid="register-staff-link">Sign up as staff</Link> instead (employees pick their designation, admin approves).
            </p>
        </div>
    );
}
